import {GetHealthDates} from 'domain/usecases';
import {RemoteGetHealthDates} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthDates = (): GetHealthDates =>
	new RemoteGetHealthDates(
		makeBFFApiUrl(BookingFlowEndPoints.healthDates),
		makeAuthorizeHttpClientDecorator(),
	);
